import React, { useContext, useEffect, useState } from "react";
import Thumbnail from "./Thumbnail";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import DropDown from "../../../../components/SVGComponents/Tools/DropDown";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import themeContext from "../../../../context/theme/ThemeContext";


const ChildStudyThumbnailList = ({
  studyData,
  startIndex,
  studyIndex,
  priors,
}) => {
  const { getConsistentDateFormat } = useContext(studyReportContext);
  const { showImpressions } = useContext(ViewportContext);
  const [dropDownClicked, setDropDownClicked] = useState(false);
  const {
    impressionHoveredStudyId,
    setImpressionHoveredStudyId,
    seriesHovered,
    setSeriesHovered,
  } = useContext(ThumbnailContext);
  const {  themeName } = useContext(themeContext);
  const handleDropDownloaClick = () => {
    setDropDownClicked(!dropDownClicked);
  };

  let timer;

  const onHovered = (e, studyId) => {
    e.stopPropagation();
    timer = setTimeout(() => {
      setImpressionHoveredStudyId(studyId);
      setSeriesHovered(true);
    }, 300);
  };

  const onHoveredOut = (e) => {
    e.stopPropagation();
    clearTimeout(timer);
    setImpressionHoveredStudyId(0);
    setSeriesHovered(false);
  };

  useEffect(() => {
    if (!seriesHovered) {
      const element = document.getElementById(
        "thumbnail_container_" + impressionHoveredStudyId
      );
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    }
  }, [impressionHoveredStudyId]);

  return (
    <React.Fragment key={studyIndex}>
      <div className="thumbnail-list-sticky-header">
        {/* <span> */}
        {studyData.stacks.length > 1 &&
          (dropDownClicked ? (
            <div className="cursor-pointer" onClick={handleDropDownloaClick}>
              <DropDown color={themeName === "light" ? "black" : "white"} />
            </div>
          ) : (
            <div
              className="cursor-pointer"
              onClick={handleDropDownloaClick}
              style={{ transform: "rotate(270deg)" }}
            >
              <DropDown color={themeName === "light" ? "black" : "white"} />
            </div>
          ))}
        {/* </span> */}
        <span>
          {getConsistentDateFormat(studyData.studyDateDisplay).slice(0, 9)}
        </span>
        <span style={{ paddingRight: "10px" }}>
          {getConsistentDateFormat(studyData.studyDateDisplay).slice(10)}
        </span>
      </div>
      {studyData.stacks?.map((stack, index) => {
        if (stack.modality === "KO" || stack.modality === "PR") return null;
        if (index === 0) {
          return (
            <div
              id={`thumbnail_container_${stack.studyId}`}
              className={`${
                stack.studyId == impressionHoveredStudyId && showImpressions
                  ? "highlight-thumbnail"
                  : ""
              }`}
              key={startIndex + index}
              style={{ paddingTop: "20px" }}
              onMouseEnter={(e) => onHovered(e, stack.studyId)}
              onMouseLeave={(e) => onHoveredOut(e)}
            >
              <Thumbnail
                stack={stack}
                index={startIndex + index}
                originalStack={studyData.originalStacks[index]}
                heatmapStack={studyData.heatmapStacks[index]}
                outlineStack={studyData.outlineStacks[index]}
                isPriors={studyIndex === 0 ? false : true}
                studyIndex={studyIndex}
                priors={priors}
                loadThumbnail={true}
              />
            </div>
          );
        }
      })}
      {dropDownClicked &&
        studyData.stacks?.map((stack, index) => {
          if (stack.modality === "KO" || stack.modality === "PR") return null;
          if (index > 0) {
            return (
              <div
                id={`thumbnail_container_${stack.studyId}`}
                className={`${
                  stack.studyId == impressionHoveredStudyId && showImpressions
                    ? "highlight-thumbnail"
                    : ""
                }`}
                key={startIndex + index}
                style={{ paddingTop: "20px" }}
                autoFocus={stack.studyId == impressionHoveredStudyId}
                onMouseEnter={(e) => onHovered(e, stack.studyId)}
                onMouseLeave={(e) => onHoveredOut(e)}
              >
                <Thumbnail
                  stack={stack}
                  index={startIndex + index}
                  originalStack={studyData.originalStacks[index]}
                  heatmapStack={studyData.heatmapStacks[index]}
                  outlineStack={studyData.outlineStacks[index]}
                  isPriors={studyIndex === 0 ? false : true}
                  studyIndex={studyIndex}
                  priors={priors}
                  startIndex={startIndex}
                  lastIndex={startIndex + studyData.stacks.length - 1}
                  dropDownClicked={dropDownClicked}
                />
                <br></br>
              </div>
            );
          }
        })}
    </React.Fragment>
  );
};

export default ChildStudyThumbnailList;
